import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavigationMenu.css';

// 画像の読み込み（パスは元のままでOKです！）
import logoMark from '../../assets/images/BohPJロゴ元データ.jpg';
import logoText from '../../assets/images/BohPJ.png';

// 先輩おすすめの react-icons を読み込み！
import { FiSearch } from 'react-icons/fi';
import { MdLanguage } from 'react-icons/md';

const NavigationMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="navigation-container">
      <div className="navigation-content">
        
        {/* 1. ロゴ部分 */}
        <div className="nav-logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logoMark} alt="BohPJ Mark" className="logo-mark" />
            <img src={logoText} alt="BohPJ Text" className="logo-text" />
          </Link>
        </div>

        {/* 2. PC・iPad用のメニュー */}
        <nav className="desktop-nav-links">
          <ul>
            <li><Link to="/news">ニュース</Link></li>
            <li><Link to="/works">実績</Link></li>
            <li><Link to="/members">メンバー</Link></li>
            <li><Link to="/resources">資料</Link></li>
          </ul>
        </nav>

        {/* 3. PC・iPad用の右側アイコン */}
        <div className="desktop-nav-actions">
          <button className="icon-button">
            {/* imgタグの代わりに react-icons を使う！ */}
            <FiSearch className="action-icon" />
          </button>
          <button className="icon-button">
            <MdLanguage className="action-icon" />
          </button>
        </div>

        {/* 4. スマホ用ハンバーガーボタン */}
        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

      </div>

      {/* --- スマホ用オーバーレイメニュー（開いた時の中身） --- */}
      <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <nav className="mobile-nav-links">
          <ul>
            <li><Link to="/news" onClick={closeMenu}>ニュース</Link></li>
            <li><Link to="/works" onClick={closeMenu}>実績</Link></li>
            <li><Link to="/members" onClick={closeMenu}>メンバー</Link></li>
            <li><Link to="/resources" onClick={closeMenu}>資料</Link></li>
            
            {/* スマホの時のアイコン */}
            <li className="mobile-actions">
              <button className="mobile-icon-button" onClick={closeMenu}>
                <FiSearch className="action-icon" />
              </button>
              <button className="mobile-icon-button" onClick={closeMenu}>
                <MdLanguage className="action-icon" />
              </button>
            </li>
          </ul>
        </nav>
      </div>

    </header>
  );
};

export default NavigationMenu;